import { ca } from '@cian/analytics';
import { IPage } from '../../../types/redux';

interface ITrackBannerShowParams {
  label: string;
  page: IPage;
}

export const trackBannerShow = ({ label, page }: ITrackBannerShowParams) => {
  ca('eventSite', {
    action: 'Show_sopr',
    category: 'Promo',
    name: 'oldevent',
    label,
    page: {
      ...page,
      extra: {
        block: label,
      },
    },
  });
};
